import * as v from "valibot";
import { rpcContract } from "../rpc";

export const getRecordingDownloadUrlRpcContract = rpcContract({
  name: "get-recording-download-url",
  paramsSchema: v.object({
    liveEventId: v.string(),
  }),
  resultSchema: v.object({
    downloadUrl: v.string(),
  }),
});

export type GetRecordingDownloadUrlParams = v.InferOutput<(typeof getRecordingDownloadUrlRpcContract)["paramsSchema"]>;
export type GetRecordingDownloadUrlResult = v.InferOutput<(typeof getRecordingDownloadUrlRpcContract)["resultSchema"]>;
